/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Toast_Users_Add_ErrorInputs */



/**
* | output |
* | --- |
* | "Space created but some users could not be added." |
*
* @param {Spaces_Wizard_Toast_Users_Add_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_toast_users_add_error = /** @type {((inputs?: Spaces_Wizard_Toast_Users_Add_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Toast_Users_Add_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Space wurde erstellt, aber einige Benutzer konnten nicht hinzugefügt werden.")
	return /** @type {LocalizedString} */ ("Space created but some users could not be added.")
});